import { call, put, takeLatest } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import * as types from '../../../actions/index.types'
import * as req from '../../../../axios/request/SocietyPortal/SocietyBankReqs/SocietyBankReqs'

function* getSocietyBanks(action) {
    try {
        const result = yield call(req.getSocietyBanksReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_SOCIETY_BANKS_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_SOCIETY_BANKS_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch bank accounts")
        }
    } catch (e) {
        yield put({ type: types.GET_SOCIETY_BANKS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getSocietyBankDetails(action) {
    try {
        const result = yield call(req.getSocietyBankDetailsReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_SOCIETY_BANK_DETAILS_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_SOCIETY_BANK_DETAILS_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch bank details")
        }
    } catch (e) {
        yield put({ type: types.GET_SOCIETY_BANK_DETAILS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* createSocietyBank(action) {
    try {
        const result = yield call(req.createSocietyBankReq, action)
        if (result.success === true) {
            toast.success(result.message || "Bank account created successfully")
            yield put({ type: types.CREATE_SOCIETY_BANK_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.CREATE_SOCIETY_BANK_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to create bank account")
        }
    } catch (e) {
        yield put({ type: types.CREATE_SOCIETY_BANK_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* updateSocietyBank(action) {
    try {
        const result = yield call(req.updateSocietyBankReq, action)
        if (result.success === true) {
            toast.success(result.message || "Bank account updated successfully")
            yield put({ type: types.UPDATE_SOCIETY_BANK_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.UPDATE_SOCIETY_BANK_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to update bank account")
        }
    } catch (e) {
        yield put({ type: types.UPDATE_SOCIETY_BANK_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* deleteSocietyBank(action) {
    try {
        const result = yield call(req.deleteSocietyBankReq, action)
        if (result.success === true) {
            toast.success(result.message || "Bank account deleted successfully")
            yield put({ type: types.DELETE_SOCIETY_BANK_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.DELETE_SOCIETY_BANK_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to delete bank account")
        }
    } catch (e) {
        yield put({ type: types.DELETE_SOCIETY_BANK_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getBankJournalEntries(action) {
    try {
        const result = yield call(req.getBankJournalEntriesReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_BANK_JOURNAL_ENTRIES_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_BANK_JOURNAL_ENTRIES_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch journal entries")
        }
    } catch (e) {
        yield put({ type: types.GET_BANK_JOURNAL_ENTRIES_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

export default function* SocietyBankSaga() {
    yield takeLatest(types.GET_SOCIETY_BANKS, getSocietyBanks)
    yield takeLatest(types.GET_SOCIETY_BANK_DETAILS, getSocietyBankDetails)
    yield takeLatest(types.CREATE_SOCIETY_BANK, createSocietyBank)
    yield takeLatest(types.UPDATE_SOCIETY_BANK, updateSocietyBank)
    yield takeLatest(types.DELETE_SOCIETY_BANK, deleteSocietyBank)
    yield takeLatest(types.GET_BANK_JOURNAL_ENTRIES, getBankJournalEntries)
    yield takeLatest(types.GET_SOCIETY_BANKS_DROPDOWN, getSocietyBanksDropdown)
}

function* getSocietyBanksDropdown(action) {
    try {
        const result = yield call(req.getSocietyBanksDropdownReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_SOCIETY_BANKS_DROPDOWN_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_SOCIETY_BANKS_DROPDOWN_FAILURE, message: result?.message })
        }
    } catch (e) {
        yield put({ type: types.GET_SOCIETY_BANKS_DROPDOWN_FAILURE, message: e?.message })
    }
}
